function pad(value, width = 2) {
  return String(value).padStart(width, "0");
}

function toDateKey(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    const fallback = new Date();
    return `${fallback.getFullYear()}${pad(fallback.getMonth() + 1)}${pad(fallback.getDate())}`;
  }
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
}

function createRandomToken(length = 6) {
  const cryptoApi = typeof window !== "undefined" ? window.crypto : undefined;
  const source =
    cryptoApi && typeof cryptoApi.randomUUID === "function"
      ? cryptoApi.randomUUID().replace(/-/g, "").toUpperCase()
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`.toUpperCase();
  return source.slice(0, length);
}

export function generateTransactionDocumentId(options = {}) {
  const prefix = String(options.prefix || "TXN").trim() || "TXN";
  const paymentDate = options.paymentDate || new Date();
  return `${prefix}-${toDateKey(paymentDate)}-${createRandomToken(6)}`;
}

export function buildNewReceiptQrValue({
  receiptNo = "-",
  studentId = "-",
  transactionId = "-",
  paymentDate = "-",
} = {}) {
  return [
    `Receipt No: ${String(receiptNo || "-").trim()}`,
    `Student ID: ${String(studentId || "-").trim()}`,
    `Transaction ID: ${String(transactionId || "-").trim()}`,
    `Payment Date: ${String(paymentDate || "-").trim()}`,
  ].join(" | ");
}
